export function getWindowHeight() {
  return Math.max(
    document.body.scrollHeight,
    document.body.offsetHeight,
    document.body.clientHeight,
    document.documentElement.scrollHeight,
    document.documentElement.offsetHeight,
    document.documentElement.clientHeight
  )
}

export function getScrollHeight() {
  return Math.min(
    document.body.scrollHeight,
    document.body.offsetHeight,
    document.body.clientHeight,
    document.documentElement.scrollHeight,
    document.documentElement.offsetHeight,
    document.documentElement.clientHeight
  )
}

export function getScrollPosition() {
  return window.scrollY || window.pageYOffset || document.documentElement.scrollTop
}
